import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogGrade } from "../models/CatalogGrade";

export const getCatalogGrades = async () => {
	const apiService = new MESApiService();

	return await apiService.callV2("[STEEL].[GetGrades]", []);
};
export const upsertCatalogGrade = async (grade: CatalogGrade) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "Id", value: grade.GradeId });
	parameters.push({ name: "Name", value: grade.GradeName });
	parameters.push({ name: "Enabled", value: grade.IsActive });
	parameters.push({ name: "Comments", value: grade.Comments });

	return await apiService.callV2("[STEEL].[UpsertCatGrade]", parameters);
};
export const getCatalogGrade = async (GradeId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "GradeId", value: GradeId });

	return await apiService.callV2("[STEEL].[GetCatGrade]", parameters);
};
export const deleteCatalogGrade = async (gradeId: number) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "GradeId", value: gradeId }];

	return await apiService.callV2("[STEEL].[DeleteGrade]", parameters);
};
type upsertCatGradeChemistryLimitProps = {
	gradeId: number;
	elementId: number;
	minValue?: number | null;
	maxValue?: number | null;
	aimValue?: number | null;
};

export const upsertCatGradeChemistryLimit = async ({
	gradeId,
	elementId,
	minValue,
	maxValue,
	aimValue,
}: upsertCatGradeChemistryLimitProps) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "GradeId", value: gradeId },
		{ name: "ElementId", value: elementId },
		{ name: "MinValue", value: minValue ?? null },
		{ name: "MaxValue", value: maxValue ?? null },
		{ name: "AimValue", value: aimValue ?? null },
	];

	return await apiService.callV2(
		"[LAB].[UpsertGradeChemistryLimit]",
		parameters,
	);
};

export const copyChemistriesLimit = async ({
	source,
	target,
}: {
	source: number;
	target: number;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SourceGradeId", value: source },
		{ name: "TargetGradeId", value: target },
	];

	return await apiService.callV2(
		"[LAB].[CopyGradeChemistryLimits]",
		parameters,
	);
};
export const getCatGradeChemistryLimits = async (gradeId: number) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "GradeId", value: gradeId }];

	return await apiService.callV2(
		"[LAB].[GetCatGradeChemistryLimitsDE]",
		parameters,
	);
};
export const deleteGradeChemistryLimit = async (
	gradeId: number,
	elementId: number,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "GradeId", value: gradeId },
		{ name: "ElementId", value: elementId },
	];

	return await apiService.callV2(
		"[LAB].[DeleteGradeChemistryLimit]",
		parameters,
	);
};
